import React, { useEffect } from 'react';
import { func, object, string, any, bool } from 'prop-types';

import queryString from 'query-string';

import loadable from '@loadable/component';
import PhoenixTheme from '@airasia/phoenix-components/components/Theme';
import FallbackCurrencyMessage from '../FallbackCurrencyMessage';
const UniversalHeader = loadable(() =>
  import(
    /* webpackChunkName:"UniversalHeader-Phoenix-SNAP" */ '@airasia/phoenix-widgets/widgets/UniversalHeader'
  )
);
const AgentHeader = loadable(() =>
  import(/* webpackChunkName:"AgentHeader-SNAP" */ './AgentHeader')
);

const AA_TOKENS = 'aa_tokens';

const shouldUpdateUserProfile = (currentProfile = {}, updatedProfile) => {
  if (currentProfile.status) return true;
  const currentSSO = currentProfile.ssoData || {};
  const currentSSOKeys = Object.keys(currentSSO);
  const updatedSSOKeys = Object.keys(updatedProfile);
  if (currentSSOKeys.length !== updatedSSOKeys.length) {
    return true;
  }
  currentSSOKeys.forEach(key => {
    if (
      typeof currentSSO[key] !== 'object' &&
      currentSSO[key] !== updatedProfile[key]
    ) {
      return true;
    }
  });
  return false;
};

const Header = props => {
  const {
    agentId,
    uhfConfig,
    credential,
    setUserProfile,
    languageParamName = 'language',
    updateCurrency = () => {},
    currency,
    selectedCurrency,
    isSupportedMultiCurrencies,
    theme,
    move,
    enableErrorRevamp,
  } = props;

  useEffect(() => {
    const handleLocale = ({ detail }) => {
      let newLocale = detail;
      const { pathname, search } = window.location;
      const currentSearch = queryString.parse(search);
      const newSearch = {
        ...currentSearch,
        [languageParamName]: newLocale,
      };
      window.history.replaceState(
        window.history.state,
        '',
        `${pathname}?${queryString.stringify(newSearch)}`
      );
      window.location.reload();
    };

    window.addEventListener('uhfLocaleChange', handleLocale);
    return () => {
      window.removeEventListener('uhfLocaleChange', handleLocale);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const handleLoginChange = async ({ detail }) => {
      if (credential && detail && setUserProfile) {
        const userInfo = await window.aaWidget.getUser();
        if (!shouldUpdateUserProfile(credential, userInfo)) return false;
        const aaTokens = localStorage.getItem(AA_TOKENS);
        setUserProfile({
          status: true,
          ssoData: userInfo,
          authInfo: aaTokens ? JSON.parse(aaTokens) : null,
        });
      }
    };

    window.addEventListener('uhfLoginChange', handleLoginChange);
    return () => {
      window.removeEventListener('uhfLoginChange', handleLoginChange);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const handleCurrency = ({ detail }) => {
      updateCurrency({ currency: detail });
    };

    window.addEventListener('uhfCurrencyChange', handleCurrency);
    return () => {
      window.removeEventListener('uhfCurrencyChange', handleCurrency);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {isSupportedMultiCurrencies && (
        <FallbackCurrencyMessage
          currency={currency}
          selectedCurrency={selectedCurrency}
          enableErrorRevamp={enableErrorRevamp}
        />
      )}
      <PhoenixTheme theme={theme}>
        <UniversalHeader
          accessible
          {...uhfConfig}
          logoWidth="148px"
          logoHeight="33px"
          move={move}
          theme={theme}
        >
          {agentId && <AgentHeader id="AgentHeader" agentId={agentId} />}
        </UniversalHeader>
      </PhoenixTheme>
    </>
  );
};

Header.propTypes = {
  agentId: string,
  uhfConfig: object,
  credential: object,
  setUserProfile: any,
  updateCurrency: func,
  languageParamName: string,
  currency: string,
  selectedCurrency: string,
  isSupportedMultiCurrencies: bool,
  theme: string,
  move: bool,
  enableErrorRevamp: bool,
};

Header.defaultProps = {
  agentId: null,
};

export default Header;
